<script setup lang="ts">
import { Heart } from 'lucide-vue-next';

type Size = 'xs' | 'sm' | 'md' | 'lg';

const props = withDefaults(
  defineProps<{
    isFavorite: boolean;
    size?: Size;
  }>(),
  { size: 'md' },
);

const emit = defineEmits<{ (e: 'toggle'): void }>();

const sizeClasses: Record<Size, string> = {
  xs: 'h-4 w-4',
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-7 w-7',
};
</script>

<template>
  <button
    type="button"
    class="btn-bare"
    :aria-pressed="isFavorite"
    @click.stop.prevent="emit('toggle')"
  >
    <Heart
      :class="[sizeClasses[size], 'text-foreground transition-colors']"
      :fill="isFavorite ? 'currentColor' : 'none'"
    />
  </button>
</template>
